module.exports = __webpack_public_path__ + "static/media/toggle-up.799109a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dublin-express/toggle-up.svg
// module id = 710
// module chunks = 0